<template>
  <div ref="button">
    <a
      href="https://twitter.com/share?ref_src=twsrc%5Etfw"
      class="twitter-share-button"
      data-size="large"
      :data-text="text"
      data-via="Qpic_Official"
      data-hashtags="Qpic"
      data-show-count="false"
      >Tweet</a
    >
  </div>
</template>

<script>
export default {
  name: "ShareButton",
  computed: {
    text() {
      if (this.content) {
        if (this.content.artist) {
          return `${this.content.title} / ${this.content.artist} | Qpic Virtual Festival`;
        } else {
          return `${this.content.title} | Qpic Virtual Festival`;
        }
      } else {
        return "Qpic Virtual Festival";
      }
    },
  },
  props: {
    content: Object,
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;
    this.$refs.button.appendChild(script);
  },
};
</script>
